import Api, { apiAction } from '../api'
import { ActionTypes } from '../constants'

function childrenRequest() {
  return {
    type: ActionTypes.CHILDREN_REQUEST
  }
}

function childrenReceived(response) {
  return {
    type: ActionTypes.CHILDREN_RECEIVING_SUCCESS,
    children: response.data,
    updatedOn: Date.now()
  }
}

function childrenReceivingFailure(error) {
  return {
    type: ActionTypes.CHILDREN_RECEIVING_FAILURE,
    error: error
  }
}

function shouldFetchChildren(state) {
  const {
    parents: {
      children: { objects, updatedOn, fetching, didInvalidate }
    }
  } = state

  if (fetching) {
    return false
  } else if (!objects || !objects.length) {
    return true
  } else if (didInvalidate) {
    return true
  } else {
    return !updatedOn || (new Date() - updatedOn) > 60000
  }
}

function fetchChildren() {
  return apiAction({
    requestor: () => Api.parents.children.index(),
    onBeforeSend: childrenRequest,
    onSuccess: (response) => childrenReceived(response),
    onFailure: (error) => childrenReceivingFailure(error)
  })
}

export function fetchChildrenIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchChildren(getState())) {
      return dispatch(fetchChildren())
    }
  }
}

function addChildRequest(child) {
  return {
    type: ActionTypes.ADD_CHILD_REQUEST,
    object: child
  }
}

function addChildSuccess(response) {
  return {
    type: ActionTypes.ADD_CHILD_SUCCESS,
    object: response.data
  }
}

function addChildFailure(error) {
  return {
    type: ActionTypes.ADD_CHILD_FAILURE,
    error: error
  }
}

export const addChild = (payload) => {
  let { name, surname, gender, grade, group_id } = payload

  return apiAction({
    requestor: () => Api.parents.children.create({ name, surname, gender, grade, group_id }),
    onBeforeSend: () => addChildRequest(payload),
    onSuccess: (response) => addChildSuccess(response),
    onFailure: (error) => addChildFailure(error)
  })
}

function updateChildRequest(child) {
  return {
    type: ActionTypes.UPDATE_CHILD_REQUEST,
    object: child
  }
}

function updateChildSuccess(response) {
  return {
    type: ActionTypes.UPDATE_CHILD_SUCCESS,
    object: response.data
  }
}

function updateChildFailure(object, error) {
  return {
    type: ActionTypes.UPDATE_CHILD_FAILURE,
    object: object,
    error: error
  }
}

export const updateChild = (payload) => {
  return (dispatch, getState) => {
    let { id, name, surname, gender, grade, login, password } = payload
    let { parents: { children: { objects } } } = getState()

    return dispatch(
      apiAction({
        requestor: () => Api.parents.children.patch({ id }, { name, surname, gender, grade, login, password }),
        onBeforeSend: () => updateChildRequest(objects[id].object),
        onSuccess: (response) => updateChildSuccess(response),
        onFailure: (error) => updateChildFailure(payload, error)
      })
    )
  }
}

function deleteChildRequest(child) {
  return {
    type: ActionTypes.DESTROY_CHILD_REQUEST,
    object: child
  }
}

function deleteChildSuccess(object, response) {
  return {
    type: ActionTypes.DESTROY_CHILD_SUCCESS,
    object: object
  }
}

function deleteChildFailure(object, error) {
  return {
    type: ActionTypes.DESTROY_CHILD_FAILURE,
    object: object,
    error: error
  }
}

export const deleteChild = (id) => {
  return (dispatch, getState) => {
    let { parents: { children: { objects } } } = getState()
    let object = objects[id].object

    return dispatch(
      apiAction({
        requestor: () => Api.parents.children.delete({ id }),
        onBeforeSend: () => deleteChildRequest(object),
        onSuccess: (response) => deleteChildSuccess(object, response),
        onFailure: (error) => deleteChildFailure(object, error)
      })
    )
  }
}

function diplomasRequest(event) {
  return {
    type: ActionTypes.CHILDREN_DIPLOMAS_REQUEST,
    event: event
  }
}

function diplomasReceived(event, response) {
  return {
    type: ActionTypes.CHILDREN_DIPLOMAS_RECEIVING_SUCCESS,
    diplomas: response.data,
    event: event,
    updatedOn: Date.now()
  }
}

function diplomasReceivingFailure(event, error) {
  return {
    type: ActionTypes.CHILDREN_DIPLOMAS_RECEIVING_FAILURE,
    event: event,
    error: error
  }
}

function fetchDiplomas(event) {
  return (dispatch) => {
    return dispatch(
      apiAction({
        requestor: () => Api.parents.diplomas({ event }).index(),
        onBeforeSend: () => diplomasRequest(event),
        onSuccess: (response) => diplomasReceived(event, response),
        onFailure: (error) => diplomasReceivingFailure(event, error)
      })
    )
  }
}

function shouldFetchDiplomas(state, event) {
  let { parents: { diplomas } } = state
  let collection = diplomas[event]

  if (!collection) { return true }

  let { object, updatedOn, fetching, didInvalidate } = collection

  if (fetching) {
    return false
  } else if (!object) {
    return true
  } else if (didInvalidate) {
    return true
  } else {
    return !updatedOn || (new Date() - updatedOn) > 60000
  }
}

export function fetchDiplomasIfNeeded(event) {
  return (dispatch, getState) => {
    if (shouldFetchDiplomas(getState(), event)) {
      return dispatch(fetchDiplomas(event))
    }
  }
}

function pretendRequest() {
  return { type: ActionTypes.PARENT_PRETEND_REQUEST }
}

function pretendSuccessful(response) {
  try { window.setGAUserID(); }
  catch(e) { console.error(e); }

  window.location = '/'

  return {
    type: ActionTypes.PARENT_PRETEND_SUCCESS
  }
}

function pretendError(error) {
  return {
    type: ActionTypes.PARENT_PRETEND_FAILURE,
    error: error
  }
}

export const pretendChild = (id) => {
  return apiAction({
    requestor: () => Api.parents.pretend({ id: id }).index(),
    onBeforeSend: pretendRequest,
    onSuccess: (response) => pretendSuccessful(response),
    onFailure: (error) => pretendError(error)
  })
}

function statisticsRequest() {
  return {
    type: ActionTypes.CHILDREN_STATISTICS_REQUEST
  }
}

function statisticsReceived(response) {
  return {
    type: ActionTypes.CHILDREN_STATISTICS_RECEIVING_SUCCESS,
    statistics: response.data,
    updatedOn: Date.now()
  }
}

function statisticsReceivingFailure(error) {
  return {
    type: ActionTypes.CHILDREN_RECEIVING_FAILURE,
    error: error
  }
}

function fetchStatistics() {
  return (dispatch, getState) => {
    return dispatch(
      apiAction({
        requestor: () => Api.parents.statistics().index(),
        onBeforeSend: () => statisticsRequest(),
        onSuccess: (response) => statisticsReceived(response),
        onFailure: (error) => statisticsReceivingFailure(error)
      })
    )
  }
}

function shouldFetchStatistics(state) {
  let { parents: { statistics } } = state
  if (!statistics) { return true }

  let { object, updatedOn, fetching, didInvalidate } = statistics

  if (fetching) {
    return false
  } else if (!object || _.isEmpty(object)) {
    return true
  } else if (didInvalidate) {
    return true
  } else {
    return !updatedOn || (new Date() - updatedOn) > 60000
  }
}

export function fetchStatisticsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchStatistics(getState())) {
      return dispatch(fetchStatistics())
    }
  }
}
